import "./Prices.css";
import React from "react";
function Prices() {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  React.useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  });

  const prices = () => {
     if (windowWidth > 768) {
      return (
        <section className="prices">
          <h3>Все цены актуальны для нового учебного года 2026-2027</h3>
          <p className="prices__text">
            Приглашаем Вас ознакомиться с нашими скидками и акциями, информацией
            о нашей лицензии и нашими программами. На все вопросы будем рады
            ответить по{" "}
            <a className="footer__linkItem link" href="tel:+79090692700">
              телефону
            </a>{" "}
            или на{" "}
            <a
              className="footer__linkItem link"
              href="https://t.me/StratfordSchool_bot"
              target="_blank"
              rel="noopener noreferrer"
            >
              бесплатном пробном уроке.
            </a>
          </p>
          <p className="prices__text">
            Обращаем Ваше внимание на то, что мы работаем только в форматах
            мини-групп (от 3х до 5 человек), парных и индивидуальных занятий. В
            нашем языковом центре мы делаем акцент на индивидуальном подходе и
            деликатно подбираем группы, ориентируясь на уровень владения языком,
            языковые потребности и эмоциональный комфорт.{" "}
          </p>
          <div className="prices__table">

            <p className="prices__format">Формат</p>
            <p className="prices__45">45 минут</p>
            <p className="prices__60">60 минут</p>

            <p className="prices__group">Группа (5-6 человек)</p>
            <p className="prices__mini">Мини-группа (3-4 человека)</p>
            <p className="prices__couple">Пара</p>
            <p className="prices__ind">Индивидуально</p>

            <div className="prices__group45">550 ₽</div>
            <div className="prices__group60">650  ₽</div>
            <div className="prices__mini45">600 ₽</div>
            <div className="prices__mini60">700 ₽</div>
            <div className="prices__couple45">750 ₽</div>
            <div className="prices__couple60">850 ₽</div>
            <div className="prices__ind45">1350 ₽</div>
            <div className="prices__ind60">1550 ₽</div>
          </div>
        </section>
      );
    }
    return (
      <section className="prices">
        <h3>Все цены актуальны для нового учебного года 2026-2027</h3>
        <p className="prices__text">
          Приглашаем Вас ознакомиться с нашими скидками и акциями, информацией о
          нашей лицензии и нашими программами. На все вопросы будем рады
          ответить по{" "}
          <a className="footer__linkItem link" href="tel:+79090692700">
            телефону
          </a>{" "}
          или на{" "}
          <a
            className="footer__linkItem link"
            href="https://t.me/StratfordSchool_bot"
            target="_blank"
            rel="noopener noreferrer"
          >
            бесплатном пробном уроке.
          </a>
        </p>
        <p className="prices__text">
          Обращаем Ваше внимание на то, что мы работаем только в форматах
          мини-групп (от 3х до 5 человек), парных и индивидуальных занятий. В
          нашем языковом центре мы делаем акцент на индивидуальном подходе и
          деликатно подбираем группы, ориентируясь на уровень владения языком,
          языковые потребности и эмоциональный комфорт.{" "}
        </p>
        <div className="prices__table">

          <p className="prices__format">Формат</p>
          <p className="prices__45">45 минут</p>
          <p className="prices__60">60 минут</p>

          <p className="prices__group">Группа (5-6 человек)</p>
          <p className="prices__mini">Мини-группа (3-4 человека)</p>
          <p className="prices__couple">Пара</p>
          <p className="prices__ind">Индивидуально</p>

          <div className="prices__group45">550 ₽</div>
            <div className="prices__group60">650  ₽</div>
            <div className="prices__mini45">600 ₽</div>
            <div className="prices__mini60">700 ₽</div>
            <div className="prices__couple45">750 ₽</div>
            <div className="prices__couple60">850 ₽</div>
            <div className="prices__ind45">1350 ₽</div>
            <div className="prices__ind60">1550 ₽</div>

        </div>
      </section>
    );
  };
  return prices();
}

export default Prices;
